<template>
    <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 0.499999L6.53109 5.75L0.468912 5.75L3.5 0.499999Z" fill="currentColor" />
    </svg>
</template>
